import Icon from "@react-native-vector-icons/material-design-icons/static";
import { TouchableOpacity } from "react-native";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import { Checkbox } from "../Checkbox";
import type { WebToolbarProps } from "./types";

const WebToolbar = ({
	selectedListItems,
	totalItemsCount,
	onSelectAll,
	onClearSelection,
	onDelete,
}: WebToolbarProps) => {
	const theme = useAppTheme();

	const getCheckboxStatus = () => {
		if (selectedListItems.length === totalItemsCount) {
			return "checked";
		}
		if (selectedListItems.length > 0) {
			return "indeterminate";
		}
		return "unchecked";
	};

	return (
		<Box
			flexDirection="row"
			gap={4}
			paddingTop={8}
			paddingLeft={4}
			paddingRight={16}
		>
			<Box width={48} height={48} justifyContent="center" alignItems="center">
				<Checkbox
					status={getCheckboxStatus()}
					onPress={onSelectAll}
					color={theme.colors.primary}
				/>
			</Box>
			{selectedListItems.length > 0 && (
				<Box flexDirection="row" gap={20} alignItems="center">
					<TouchableOpacity onPress={onClearSelection}>
						<Box
							flexDirection="row"
							borderWidth={1}
							borderColor={theme.colors.onSurfaceVariant}
							borderRadius={8}
							gap={8}
							paddingVertical={6}
							paddingLeft={12}
							paddingRight={8}
						>
							<Text
								style={{ color: theme.colors.onSurfaceVariant }}
								variant="labelLarge"
							>
								{selectedListItems.length} selected
							</Text>
							<Icon
								name="close"
								size={18}
								color={theme.colors.onSurfaceVariant}
							/>
						</Box>
					</TouchableOpacity>
					<TouchableOpacity onPress={() => onDelete(selectedListItems)}>
						<Box
							flexDirection="row"
							alignItems="center"
							justifyContent="center"
							width={48}
							height={48}
						>
							<Box height={"100%"} paddingVertical={12}>
								<Box
									height={"100%"}
									width={1}
									backgroundColor={theme.colors.outlineVariant}
								/>
							</Box>
							<Box
								justifyContent="center"
								alignItems="center"
								width={48}
								height={48}
							>
								<Icon
									name="delete-outline"
									size={24}
									color={theme.colors.onSurfaceVariant}
								/>
							</Box>
						</Box>
					</TouchableOpacity>
				</Box>
			)}
			<Box flex={1} />
			<Box justifyContent="center">
				<Text variant="bodyLarge">{totalItemsCount} memories</Text>
			</Box>
		</Box>
	);
};

export default WebToolbar;
